export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-bookmark-line',
      title: '海量免费资源',
      desc: '收录超10万部日漫、韩漫、国漫资源，全部免费在线阅读，拒绝付费墙和隐藏收费。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '下拉式阅读',
      desc: '专为移动端优化的竖屏滚动阅读模式，如翻阅真实漫画般的自然流畅体验。',
    },
    {
      icon: 'ri-time-line',
      title: '每日稳定更新',
      desc: '热门连载作品保持每日同步更新，完结作品完整收录，绝不断更让漫迷失望。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全无广告',
      desc: '纯净的阅读环境，无弹窗广告干扰，不收集用户隐私数据，专注提供优质阅读服务。',
    },
  ];

  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">为什么选迷妹</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            数百万漫迷的共同选择，迷妹漫画的独特优势让你爱上免费漫画阅读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 max-w-5xl mx-auto">
          {features.map((feat, i) => (
            <div key={i} className="text-center p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors group cursor-pointer">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-accent-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feat.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-2">{feat.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}